import { BaseModel } from "sjs-base-model";

export default class BreadcrumbLinkModel extends BaseModel {
    public readonly code: string = "";
    public readonly level: number = 0;
    public readonly label: string = "";
    public readonly title: string = "";
    public readonly path: string = "";
    public readonly sub?: BreadcrumbLinkModel[] = undefined;

    constructor(data: Partial<BreadcrumbLinkModel>) {
        super();

        this.update(data);
    }
}
